var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "docs.markdown.block",
  title: "Docs Markdown Block",
  description: "Renders markdown content as HTML in both server and client environments.",
  supportServer: true,
  fields: {
    inner: {
      title: "Markdown Content",
      type: "string",
      description: "Markdown content to render.",
      required: true
    },
    class: {
      title: "Class",
      type: "string",
      description: "Additional classes applied to the wrapper element.",
      required: false
    },
    id: {
      title: "ID",
      type: "id",
      description: "Optional element id.",
      required: false
    }
  },
  passthrough: {
    except: ["inner"]
  }
});

var markdown = require("../modules/markdown.engine.js");
var jsonRender = require("../../../uat/src/interface/jsonRender.js");

function convertDomToHtml(dom) {
  if (dom === null || dom === undefined) {
    return "";
  }

  if (Array.isArray(dom)) {
    var html = "";
    for (var i = 0; i < dom.length; i++) {
      if (dom[i] && dom[i].outerHTML) {
        html += dom[i].outerHTML;
      }
    }
    return html;
  }

  if (dom.outerHTML) {
    return dom.outerHTML;
  }

  return dom + "";
}

async function renderUAJsonPreview(rawUAJson) {
  try {
    var parsed = JSON.parse(rawUAJson);
    var dom = await jsonRender.render(parsed, {
      noPlaceholder: true
    });

    return convertDomToHtml(dom);
  } catch (error) {
    return '<div class="alert alert-warning">Unable to render UA/JSON preview: '
      + (error && error.message ? error.message : "Unknown error")
      + "</div>";
  }
}

async function render(options) {
  var wrapper = document.createElement("section");
  wrapper.className = "docs-markdown-block";

  if (options && typeof options.class === "string" && options.class.trim()) {
    wrapper.className += " " + options.class.trim();
  }

  if (options && typeof options.id === "string" && options.id.trim()) {
    wrapper.id = options.id.trim();
  }

  var markdownText = "";
  if (options && typeof options.inner === "string") {
    markdownText = options.inner;
  }

  var rendered = await markdown.renderMarkdown(markdownText, {
    renderUAJson: renderUAJsonPreview
  });

  wrapper.innerHTML = rendered.html || "";
  return wrapper;
}
module.exports.render = render;
